import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { confirmations } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'confirmations', element: <ModuleLayout />,
    handle: { title: i18n.t('confirmations.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'confirmations:read', exclude: true },
      },
      // { path: 'new', element: <Form />,
      //   handle: { title: i18n.t('confirmations.new'), permission: 'confirmations:create' },
      // },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => confirmations.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (confirmation: any) => (confirmation && i18n.t('confirmations.edit', confirmation)), permission: 'confirmations:update' },
      },
    ],
  },
];
